// extracted by mini-css-extract-plugin
module.exports = {"icon":"wmxLt5Jm"};